import { useEffect, useState, useContext, useCallback, useRef } from "react";
import { getAllSubscription } from "api/graphQL_subscriptions";
import { getAllGatewaysSecond } from "api/graphQL_gateways";
import SubscriptionList from "./components/subscriptionlist";
import { ClientContext } from "ClientProvider";
import DivLoader from "components/divloader/DivLoader";
export type SubscriptionObj = {
  start_date: string;
  interval: string;
  managed_by:any;
  duration: number;
  amount: number;
  gateway_hash: string;
  currency: string;
  gateway_name: string;
  descriptor: string;
  paid_payments: number;
  transaction: string;
  billing_cycles: number;
  status: string;
  id: string;
  client: string;
  client_id:string;
  client_secret:string;
  subscription_id: string;
  subscription_provider : string;
  subscription_provider_name : string;
  payment: any;
  created_at: any;
  next_payment_date: any;
};
const Subscription = () => {
  const [subscriptions, setSubscriptions] = useState<SubscriptionObj[]>([]);
  const [isListLoading, setIsListLoading] = useState<boolean>();
  const [page, setPage] = useState<number>(1);
  const [totalpage, setTotalPage] = useState<number>(0);
  const [totalItems, setTotalItems] = useState<number>(1);
  const [statusChanged,setStatusChanged] = useState(false);
  const [pageSize, setPageSize] = useState<number>(50);
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [searchTexts, setSearchTexts] = useState<string>("");
  const [allGateways, setAllGateways] = useState<any[]>([]);
  const { singleRoleData } = useContext(ClientContext);
  const [isRoleDataLoaded, setIsRoleDataLoaded] = useState(false);
  const firstRender = useRef(true);
  const isResetting = useRef(false);
  const [clearClicked,setClearClick] = useState(0)


  useEffect(() => {
    if (Array.isArray(singleRoleData) && singleRoleData.length > 0) {
      setIsRoleDataLoaded(true);
    }
  }, [singleRoleData]);
  const [filter, setFilter] = useState({
    clients: [],
    interval: [],
    duration: null,
    status: [],
  });
  const fetchSubscriptions = useCallback(() => {
    setIsListLoading(true);
    if (pageSize === null || pageSize === undefined) {
      setIsListLoading(false);
      return;
    }
    const params = { page: page, per_page: pageSize, searchTexts: searchTexts,filter:filter };
    getAllSubscription(params)
      .then((data) => {
        setSubscriptions(data?.subscriptions ?? []);
        setTotalPage(data.total_pages);
        setTotalItems(data.total_items);
        setCurrentPage(data.current_page);
      })
      .catch((err) => {
        setSubscriptions([]);
      })
      .finally(() => {
        setIsListLoading(false);
      });
  },[page,pageSize,searchTexts]);

  const fetchAllGateways = useCallback(() => {
    getAllGatewaysSecond()
      .then((data) => {
        setAllGateways(data);
      })
      .catch((err) => {
      })
      .finally(() => {
      });
  },[]);

  useEffect(() => {
    fetchAllGateways();
  }, [fetchAllGateways]);

  const serchboxValueChange = async (searchTerm: string) => {
    const search_txt = searchTerm || "";
    if (search_txt !== searchTexts && searchTexts !== "") {
      await setSearchTexts(search_txt);
      setPage(1);
      setCurrentPage(1);
    } else {
      await setSearchTexts(search_txt);
    }
  };
  const filterData = () => {
    setIsListLoading(true);
    if (pageSize === null || pageSize === undefined) {
      setIsListLoading(false);
      return;
    }
    const params = { page: page, per_page: pageSize, searchTexts: searchTexts,filter:filter};
    getAllSubscription(params)
      .then((data) => {
        setSubscriptions(data?.subscriptions ?? []);
        setTotalPage(data.total_pages);
        setTotalItems(data.total_items);
        setCurrentPage(data.current_page);
      })
      .catch((err) => {
        setSubscriptions([]);
      })
      .finally(() => {
        setIsListLoading(false);
      });
  };

  // const fetchSearchs = useCallback(() => {
  //   fetchSubscriptions();
  // },[fetchSubscriptions]);

  useEffect(() => {

    if (firstRender.current) {
      firstRender.current = false;
      return;
    }

    if (isResetting.current) {
      isResetting.current = false;
      return;
    }
    if(clearClicked) {
      setFilter(
        {
          clients: [],
          interval: [],
          duration: null,
          status: [],
        }
      )
    }
    fetchSubscriptions();
  }, [searchTexts, page, pageSize,statusChanged,isRoleDataLoaded,fetchSubscriptions , clearClicked]);

  // useEffect(() => {
  //   isResetting.current = true;  
  //   setPage(1)
  //   setPageSize(50)
  // },[filter?.status, filter?.clients, filter?.duration, filter?.interval])

  useEffect(() => {
    onClearClick()
    // fetchSubscriptions()
  },[])

  const onClearClick = () => {
    setClearClick((prev) => {
      const newCount = prev + 1;
      return newCount;
    });
  };

  useEffect(() => {
      setPageSize(50)
    },[searchTexts])

  return (
    <>
      <div className="mt-5">
        {isRoleDataLoaded && allGateways.length > 0 ? (
          <SubscriptionList
            pageSize={pageSize}
            setPageSize={setPageSize}
            data={subscriptions}
            isLoading={isListLoading}
            page={page}
            setPage={setPage}
            totalpage={totalpage}
            totalItems={totalItems}
            currentPage={currentPage}
            onValueChange={serchboxValueChange}
            roleData={singleRoleData}
            allGateways={allGateways}
            fetchSubscriptions={fetchSubscriptions}
            filterData={filterData}
            filter={filter}
            setFilter={setFilter}
            setClearClick={onClearClick}
            setStatusChanged={setStatusChanged}
            setIsLoading={setIsListLoading}
          />
        ): (
          <div className="mt-5 pt-5">
              <DivLoader className="m-5 h-6 w-6 border-indigo-500" />
              <p className="text-center">Loading, please wait...</p>
          </div>
        )}
      </div>
    </>
  );
};
export default Subscription;
